var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.alerts),function(alert){return _c('b-alert',{key:alert.id,attrs:{"variant":"danger","show":"","dismissible":""}},[_vm._v("\n    "+_vm._s(alert.content)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }